const $ = require('jquery');

window.googleMapCallbackFn = function() {
    googleMap.loaded();
};

function GoogleMap(apiKey) {
    this.apiKey = apiKey;
    this.isReady = false;
    this.callbacks = [];
}

function checkThenLoadMapApi(apiKey) {
    if (window.MarkerClusterer) {
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&language=se&callback=googleMapCallbackFn';
        script.type = 'text/javascript';
        script.defer = '1';
        script.async = '1';

        // Fire the loading
        document.head.appendChild(script);
    } else {
        console.log('waiting for MarkerClusterer');
        setTimeout(() => {
            checkThenLoadMapApi(apiKey);
        }, 100);
    }
}

GoogleMap.prototype.init = function() {
    checkThenLoadMapApi(this.apiKey);
};

GoogleMap.prototype.onReady = GoogleMap.prototype.ready = function(callback) {
    if (this.isReady) {
        callback.apply();
    } else {
        this.callbacks.push(callback);
    }
};

GoogleMap.prototype.loaded = function () {
    this.isReady = true;
    for (let i = 0; i < this.callbacks.length; i++) {
        this.callbacks[i].apply();
    }
};

const googleMap = new GoogleMap(window.GOOGLE_MAP_API_KEY);
googleMap.init();

module.exports = googleMap;



// WEBPACK FOOTER //
// ./resources/assets/js/gmap.js